import React from "react";
import { Book } from "../data/books";
import styles from "./BookCard.module.css";
import "../i18n";
import { useTranslation } from "react-i18next";

interface Props {
  book: Book;
  onOpen?: (book: Book) => void;
}

const BookCard: React.FC<Props> = ({ book, onOpen }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.card} onClick={() => onOpen?.(book)}>
      <span
        className={styles.badge}
        style={{
          background: book.color,
          color: book.textColor,
          border: `1px solid ${book.color}44`,
        }}
      >
        {t(`books.${book.id}.badge`, { defaultValue: book.badge })}
      </span>
      <div
        className={styles.imageWrap}
        style={{ "--glow-color": book.color } as React.CSSProperties}
      >
        <img
          src={book.image}
          alt={book.title}
          className={styles.image}
          loading="lazy"
        />
      </div>
      <div className={styles.body}>
        <h3 className={styles.title}>
          {t(`books.${book.id}.title`, { defaultValue: book.title })}
        </h3>
        <p className={styles.description}>
          {t(`books.${book.id}.description`, {
            defaultValue: book.description,
          })}
        </p>
        <button
          className={styles.btn}
          style={{ color: book.color, borderColor: book.color + "55" }}
          onClick={(event) => {
            event.stopPropagation();
            onOpen?.(book);
          }}
          type="button"
        >
          {t("book.select")}
        </button>
      </div>
    </div>
  );
};

export default BookCard;
